module.exports = __webpack_public_path__ + "img/252.invoice_submitted.1a6b609a.svg";